import { GenericArrayServiceResponse, ResponseCachedDecorator } from '@nts/std';
import { ResponseResultTypeDecorator } from '@nts/std';
import { MenuNodeDataDto } from '../domain-models/dto/menu-node-data.dto';

@ResponseResultTypeDecorator(MenuNodeDataDto)
@ResponseCachedDecorator()
export class GetAllNodesResponse extends GenericArrayServiceResponse<MenuNodeDataDto> {

}
